import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Image } from '@chatterbug/aaron'

import VerticalDivider from '../VerticalDivider/VerticalDivider'

const StatItem = ({ icon, number, label, divider = true }) => {
  return (
    <Flex mr={{ _: '1x', mobile: 40, tabletWide: 0 }}>
      {divider && <VerticalDivider />}
      <Flex flexDirection="column" ml={{ _: '1x', mobile: '3x' }}>
        <Flex>
          <Image src={icon || null} mr="1x" />
          <Box
            as="h4"
            variant="text.h4"
            color={number > 0 ? 'black0' : 'gray60'}
          >
            {number}
          </Box>
        </Flex>
        <Box
          variant="text.tinyTitle"
          color="gray60"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {label}
        </Box>
      </Flex>
    </Flex>
  )
}

StatItem.propTypes = {
  icon: PropTypes.any,
  number: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  divider: PropTypes.bool,
}

export default StatItem
